
import Enumerable from "linq";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { DocumentSearchPresetCondition, SearchConditionPresetKinds, } from "../../../../domain/document";

interface IPresetKindsName {
  name: string;
  presetName: string;
}

@Component
export default class SearchConditionPresetSortMixin extends Mixins() {
  @Prop()
  presets: DocumentSearchPresetCondition[];

  @Emit()
  orderSaved(): void {}

  data(): any {
    return {
      isProcessiong: false,
      options: null,
      selectedOption: null,
    };
  }
  isProcessiong: boolean;
  options: DocumentSearchPresetCondition[];
  selectedOption: DocumentSearchPresetCondition;

  mounted() {
    this.options = this.createOptions(this.presets);
  }

  private get _presetKinds(): { [key in SearchConditionPresetKinds]: IPresetKindsName; } {
    return {
      [SearchConditionPresetKinds.Person] : { name: "個人", presetName: "個）プリセット", },
      [SearchConditionPresetKinds.Department] : { name: "診療科", presetName: "診）プリセット", },
      [SearchConditionPresetKinds.All] : { name: "全科", presetName: "全）プリセット", },
    };
  }

  get hasSelectedItem(): boolean {
    return !!this.selectedOption;
  }

  get isTopSelected(): boolean {
    return this.hasSelectedItem
        && this.isSelectedOption(this.options[0]);
  }

  get isBottomSelected(): boolean {
    return this.hasSelectedItem
      && this.isSelectedOption(this.options[this.options.length - 1]);
  }

  isSelectedOption(option: DocumentSearchPresetCondition): boolean {
    return this.selectedOption === option;
  }

  toPresetKind(row: DocumentSearchPresetCondition): string {
    if (!row) { return ""; }
    return this._presetKinds[row.presetKind]
      ? this._presetKinds[row.presetKind].name
      : "不明";
  }

  toName(row: DocumentSearchPresetCondition): string {
    return row.name ? row.name : this.toPresetTemporaryName(row);
  }

  toPresetTemporaryName(condition: DocumentSearchPresetCondition): string {
    return this._presetKinds[condition.presetKind]
      ? this._presetKinds[condition.presetKind].presetName + condition.index
      : "名前無し";
  }

  createOptions(presets: DocumentSearchPresetCondition[]) {
    return Enumerable.from(presets).where(c => !!c.key).toArray();
  }

  moveItems(offset: number) {
    const index = this.options.indexOf(this.selectedOption);
    this.moveItem(index, offset);
  }

  moveItem(index: number, offset: number) {
    const item = this.options[index];
    this.options.splice(index, 1);
    this.options.splice(index + offset, 0, item);
  }

  async save() {
    try {
      this.isProcessiong = true;
      const repository = DomainRegistry.document.getDocumentRepository();
      await repository.registerPresetOrder(Enumerable.from(this.options).select(o => o.key).toArray());
      this.orderSaved();
      this.$success("プリセット並び順登録成功", "文書一覧検索プリセットの並び順を登録しました。");
    } catch (e) {
      this.$error("失敗", "プリセットの並び順登録に失敗しました。", e);
    } finally {
      this.isProcessiong = false;
    }
  }

  @Watch("presets")
  onPresetsChanged(newValue: DocumentSearchPresetCondition[]) {
    this.options = this.createOptions(newValue);
  }

  onCurrentChange(row: DocumentSearchPresetCondition) {
    this.selectedOption = row;
  }
}
